import React from 'react'
import styled from 'styled-components'
import { Tooltip } from 'antd'
import { NavLink } from 'react-router-dom'
import 'antd/dist/antd.css'
import resumePDF from '../Assets/Files/resume.pdf'

const Navigation = () => {
  const openResume = () => window.open(resumePDF)

  return (
    <Wrapper>
      <List>
        <ListItem to="/about">About</ListItem>
        <ListItem to="/projects">Projects</ListItem>
        <ListItem to="/contacts">Contacts</ListItem>
        <Tooltip placement="right" title="See Resume">
          <Link onClick={openResume} target="__blank">
            Resume
          </Link>
        </Tooltip>
      </List>
    </Wrapper>
  )
}

const Wrapper = styled.nav`
  margin-top: 40px;
  margin-right: 40px;

  @media screen and (max-width: 569px) {
    margin-right: 0;
    margin-top: 20px;
  }
`

const List = styled.ul`
  display: flex;
  height: 50px;

  @media screen and (max-width: 569px) {
    flex-direction: column;
  }
`

const ListItem = styled(NavLink)`
  list-style: none;
  font-family: Ubuntu, sans-serif;
  font-size: 16px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  color: #ffffff !important;
  z-index: 1;

  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;

  position: relative;
  padding: 15px;
  transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);

  :nth-child(2),
  :nth-child(3) {
    margin-left: 30px;
  }

  &:hover {
    color: #fbff12;
    background-color: #1d2f6f;
    border-bottom: 7px solid #152356;
  }

  &:active {
    border-bottom: 0px;
  }

  @media screen and (max-width: 569px) {
    :nth-child(1),
    :nth-child(2),
    :nth-child(3) {
      text-align: center;
      margin: 0;
    }
  }
`

const Link = styled.a`
  list-style: none;
  font-family: Ubuntu, sans-serif;
  font-size: 16px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  color: #ffffff !important;
  z-index: 1;

  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;

  position: relative;
  padding: 15px;
  transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
  margin-left: 30px;

  &:hover {
    color: #fbff12;
    background-color: #1d2f6f;
    border-bottom: 7px solid #152356;
  }

  &:active {
    border-bottom: 0px;
  }

  @media screen and (max-width: 569px) {
    margin: 0;
    text-align: center;
  }
`

export default Navigation
